import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PandabuySpreadsheetGuide from "../pages/blog/pandabuy-spreadsheet-guide/page";
import PandabuyShoesGuide from "../pages/blog/pandabuy-shoes-guide/page";
import PandabuyHoodiesGuide from "../pages/blog/pandabuy-hoodies-guide/page";
import PandabuyTshirtsGuide from "../pages/blog/pandabuy-tshirts-guide/page";
import PandabuyJacketsGuide from "../pages/blog/pandabuy-jackets-guide/page";
import PandabuyPantsGuide from "../pages/blog/pandabuy-pants-guide/page";
import PandabuyAccessoriesGuide from "../pages/blog/pandabuy-accessories-guide/page";
import PandabuyBagsGuide from "../pages/blog/pandabuy-bags-guide/page";
import PandabuyPerfumesGuide from "../pages/blog/pandabuy-perfumes-guide/page";
import PandabuySafetyGuide from "../pages/blog/pandabuy-safety-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog/pandabuy-spreadsheet-buying-guide",
    element: <PandabuySpreadsheetGuide />,
  },
  {
    path: "/blog/pandabuy-shoes-guide",
    element: <PandabuyShoesGuide />,
  },
  {
    path: "/blog/pandabuy-hoodies-guide",
    element: <PandabuyHoodiesGuide />,
  },
  {
    path: "/blog/pandabuy-tshirts-guide",
    element: <PandabuyTshirtsGuide />,
  },
  {
    path: "/blog/pandabuy-jackets-guide",
    element: <PandabuyJacketsGuide />,
  },
  {
    path: "/blog/pandabuy-pants-guide",
    element: <PandabuyPantsGuide />,
  },
  {
    path: "/blog/pandabuy-accessories-guide",
    element: <PandabuyAccessoriesGuide />,
  },
  {
    path: "/blog/pandabuy-bags-guide",
    element: <PandabuyBagsGuide />,
  },
  {
    path: "/blog/pandabuy-perfumes-guide",
    element: <PandabuyPerfumesGuide />,
  },
  {
    path: "/blog/pandabuy-safety-guide",
    element: <PandabuySafetyGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;